// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__dmRuf","choiceBoxes":"toolbarselects_choiceBoxes__2HzoV","simpleField":"toolbarselects_simpleField__1-Ph6"};